export default __webpack_public_path__ + "61d7179219e1e39d586ae946ac203b0e.svg";